import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
// import { get_all_users } from '../../redux/actions/userAuthActions'
import avatar from '../../assets/avatar.png'
import { Link } from 'react-router-dom'
import Loader from '../../components/Loader'
// import {
// } from '../../redux/types'

const DashboardHome = () => {
	const dispatch = useDispatch()

	const { loading, admin } = useSelector((state) => state.authLogin)

	// useEffect(() => {
	// 	dispatch(get_all_users())

	// 	return () => {
	// 		dispatch({ type: GET_ALL_USERS_RESET })
	// 	}
	// }, [dispatch])

	return (
		<>
			<section className='user_dashboard'>
				{loading ? (
					<Loader />
				) : admin ? (
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-md-9'>
								<div className='row'>
									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											{admin.profileImage ? (
												<div className='home_image_box'>
													<img src={admin.profileImage} alt='' />
												</div>
											) : (
												<img src={avatar} alt='' />
											)}

											<p>
												{admin.firstName} {admin.lastName}
											</p>

											<hr />

											<p> {admin.email} </p>
										</div>
									</div>

									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											<p className='mt-4'> Total No of Submissions </p>
											<h1>0</h1>
											<hr />
										</div>
									</div>

									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											<p> Current Campaign(s) </p>
											<h1>0</h1>
										</div>
									</div>

									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											<p className='mt-4'> No of Users </p>
											<h1>0</h1>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				) : (
					'No data to be displayed'
				)}
			</section>
		</>
	)
}

export default DashboardHome
